// modalId.js
'use strict';

export const login = {
  METHOD_SELECT: 'LoginMethodSelect',
  FORGOT_PASSWORD_EMAIL: 'ForgotPasswordEmail',
  FORGOT_PASSWORD_PHONE: 'ForgotPasswordPhone',
  PASSWORD: 'LoginPassword',
  PHONE: 'LoginPhone',
  PHONE_COUNTRY_SELECT: 'LoginCountrySelect',
  PHONE_VERIFY: 'LoginPhoneVerify',
  EMAIL: 'LoginEmail',
  EMAIL_VERIFY: 'login.EmailVerify',
  EMAIL_REFILL: 'login.EmailRefill',
  QR_CODE: 'LoginQRCode',
  SWITCH_ALERT: 'LoginSwitchAlert',
  REGISTER_START: 'RegisterStartMethodSelect',
  ACCOUNT_REGISTER: 'AccountRegister',
  FORGOT_PASSWORD_EMAIL_VERIFY: 'ForgotPasswordEmailVerify',
  FORGOT_PASSWORD_PHONE_VERIFY: 'ForgotPasswordPhoneVerify',
  AGE_VERIFICATION_OPTIONS: 'AgeVerificationOptions',
};

export const register = {
  START_REGISTER_ALERT: 'StartRegisterAlert',
  CONTINUE_REGISTER_ALERT: 'ContinueRegisterAlert',
  REGISTER: 'Register',
  REGISTER_EMAIL: 'RegisterEmail',
  EMAIL_VERIFY: 'register.EmailVerify',
  EMAIL_BIND_CONFIRM: 'EmailBindConfirm',
  REGISTER_EMAIL_LOGOUT: 'RegisterEmailLogout',
  EMAIL_REFILL: 'register.EmailRefill',
  EMAIL_BIND_ALERT: 'EmailBindAlert',
  APPLE_MIGRATION_ALERT: 'AppleMigrationAlert',
};

export const addvalue = {
  DIAMOND_PACK_SELECTOR: 'DiamondPackSelector',
  CURRENCY_SELECTOR: 'CurrencySelector',
  ORDER_SUMMARY: 'addvalue.OrderSummary',
  PAYMENT_SOURCE_SELECTOR: 'addvalue.PaymentSourceSelector',
  CONFIRM_ORDER_EMAIL_INPUT: 'addvalue.ConfirmOrderEmailInput',
  TAPPAY_CARD_FORM: 'addvalue.TappayCardFormModal',
  CENTROBILL_CARD_FORM: 'addvalue.CentrobillCardFormModal',
  SECURIONPAY_CARD_FORM: 'addvalue.SecurionpayCardFormModal',
  ECPAY_CARD_FORM: 'addvalue.EcpayCardFormModal',
  ECPAY_APPLE_PAY: 'addvalue.EcpayApplePay',
  NINEONE_APP_CARD_FORM: 'addvalue.NineoneAppCardFormModal',
  NINEONE_APP_APPLE_PAY: 'addvalue.NineoneAppApplePay',
  ORDER_COMPLETE_ALERT: 'addvalue.OrderCompleteAlert',
  ORDER_PROCESSING_ALERT: 'addvalue.OrderProcessingAlert',
  ORDER_COMPLETE_IN_APP_ALERT: 'addvalue.OrderCompleteInAppAlert',
  ORDER_PROCESSING_IN_APP_ALERT: 'addvalue.OrderProcessingInAppAlert',
  CHINA_OTHER_PAYMENT: 'addvalue.ChinaOtherPayment',
  PRODUCT_NOTICE_MODAL: 'ProductNoticeModal',
  SHOP_REMOVE_PAYMENT_SOURCE_ALERT: 'ShopRemovePaymentSourceAlert',
  MISSION_CENTER: 'MissionCenter',
};

export const backpack = {
  TICKET_MODAL: 'TicketModal',
};

export default {
  login,
  register,
  addvalue,
  backpack,
};
